import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "layouts/Footer";

// const iframe = '<iframe ng-src="https://www.aensaecuador.org/catastro/" width="1250" height="800"></iframe>'

function CatastroNacionalPorEspecie() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <iframe
        src="https://app.powerbi.com/reportEmbed?reportId=a4fa4368-8e77-4e8b-86f6-20ef7ac61d7b&autoAuth=true&ctid=b76a9200-d94c-4e4c-8d97-a30d49fbfd24"
        width="100%"
        height="800"
      ></iframe>
      <Footer />
    </DashboardLayout>
  );
}

export default CatastroNacionalPorEspecie;
